export const nightLife = [
  {
    type: "restaurant",
    info: {
      resId: 18567806,
      name: "Branch Kitchen And Bar",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/6/18567806/53836dc1ce35ea7263da0751e2729b1d_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/6/18567806/53836dc1ce35ea7263da0751e2729b1d_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/6/18567806/8dc6bcf2207582cbbaff2781065a8647_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.0",
        rating_text: "4.0",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "759",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.3",
            reviewCount: "679",
            reviewTextSmall: "679 Reviews",
            subtext: "679 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.3",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "3.7",
            reviewCount: "80",
            reviewTextSmall: "80 Reviews",
            subtext: "80 Delivery Reviews",
            color: "#E23744",
            ratingV2: "3.7",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹2,400 for two"
      },
      cfo: {
        text: "₹500 for one"
      },
      locality: {
        name: "South Extension 2, New Delhi",
        address: "E23, 3rd Floor, South Extension 2, New Delhi",
        localityUrl: "ncr/south-extension-2-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/asian/",
          name: "Asian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/italian/",
          name: "Italian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/continental/",
          name: "Continental"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzA0XCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/sandwich/",
          name: "Sandwich"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc3XCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/sushi/",
          name: "Sushi"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/desserts/",
          name: "Desserts"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/pizza/",
          name: "Pizza"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹2,400 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/branch-kitchen-and-bar-south-extension-2-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "3.2 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"2de9f85c-edd4-4afc-9c37-84016ba1773f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"nightlife","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18567806","element_type":"listing","rank":94}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 20059539,
      name: "Skol",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/9/20059539/b90955128bf8aa3c537beabc7158d5b3_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/9/20059539/b90955128bf8aa3c537beabc7158d5b3_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url: false
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.2",
        rating_text: "4.2",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "239",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.2",
            reviewCount: "235",
            reviewTextSmall: "235 Reviews",
            subtext: "235 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.2",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "",
            reviewCount: "4",
            reviewTextSmall: "4 Reviews",
            subtext: "Does not offer Delivery",
            color: "",
            ratingV2: "-",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹1,800 for two"
      },
      cfo: {
        text: "₹500 for one"
      },
      locality: {
        name: "South Extension 2, New Delhi",
        address: "D-14, Third Floor, South Extension 2, New Delhi",
        localityUrl: "ncr/south-extension-2-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/continental/",
          name: "Continental"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/chinese/",
          name: "Chinese"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/biryani/",
          name: "Biryani"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODNcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/sea-food/",
          name: "Seafood"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/pizza/",
          name: "Pizza"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NFwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/pasta/",
          name: "Pasta"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/desserts/",
          name: "Desserts"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹1,800 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/skol-1-south-extension-2-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "3.1 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"2de9f85c-edd4-4afc-9c37-84016ba1773f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"nightlife","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"20059539","element_type":"listing","rank":95}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "booking_cta",
        text: "Book a Table",
        clickUrl: "/ncr/skol-1-south-extension-2-new-delhi/book"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 19291541,
      name: "MIC Drop",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/1/19291541/0b6ae3cd4664211f99ad35681c0d80b9_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/1/19291541/0b6ae3cd4664211f99ad35681c0d80b9_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/1/19291541/fe40bc819dc2fa8cd9295f372992fc40_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.0",
        rating_text: "4.0",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "238",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.0",
            reviewCount: "237",
            reviewTextSmall: "237 Reviews",
            subtext: "237 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.0",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "",
            reviewCount: "1",
            reviewTextSmall: "1 Reviews",
            subtext: "Does not offer Delivery",
            color: "",
            ratingV2: "-",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹2,500 for two"
      },
      cfo: {
        text: "₹500 for one"
      },
      locality: {
        name: "Feroze Shah Road, New Delhi",
        address: "M-4, Feroze Shah Road, New Delhi",
        localityUrl: "ncr/feroze-shah-road-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/chinese/",
          name: "Chinese"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/italian/",
          name: "Italian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/continental/",
          name: "Continental"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹2,500 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/mic-drop-feroze-shah-road-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "2.8 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"2de9f85c-edd4-4afc-9c37-84016ba1773f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"nightlife","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19291541","element_type":"listing","rank":96}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "booking_cta",
        text: "Book a Table",
        clickUrl: "/ncr/mic-drop-feroze-shah-road-new-delhi/book"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 20547581,
      name: "Nomimono",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/1/20547581/f1d79684206d58c2ee85e006a99079a5_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/1/20547581/f1d79684206d58c2ee85e006a99079a5_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url: false
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "0",
        rating_text: "-",
        rating_subtitle: "Not rated",
        rating_color: "CBCBCB",
        votes: "0",
        subtext: "REVIEW",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "",
            reviewCount: "0",
            reviewTextSmall: "0 Reviews",
            subtext: "Does not offer Dining",
            color: "",
            ratingV2: "-",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "",
            reviewCount: "0",
            reviewTextSmall: "0 Reviews",
            subtext: "Does not offer Delivery",
            color: "",
            ratingV2: "-",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹2,000 for two"
      },
      cfo: {
        text: "₹500 for one"
      },
      locality: {
        name: "Epicuria Food Mall, Nehru Place, New Delhi",
        address:
          "R8, Upper Ground Floor, Epicuria Food Mall, Astha Kunj Road, Nehru Place, New Delhi",
        localityUrl: "ncr/restaurants/in/epicuria-mall-nehru-place"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNjBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/japanese/",
          name: "Japanese"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc3XCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/sushi/",
          name: "Sushi"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/asian/",
          name: "Asian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjI3XCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/bar-food/",
          name: "Bar Food"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹2,000 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/nomimono-nehru-place-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "702 m",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"2de9f85c-edd4-4afc-9c37-84016ba1773f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"nightlife","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"20547581","element_type":"listing","rank":97}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 1037,
      name: "Cafe Rendezvous",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/7/1037/529f2963c3cd5de743ce3701d82afc08_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/7/1037/529f2963c3cd5de743ce3701d82afc08_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/7/1037/223ea72b9ff420b75f0652b2e081b710_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.8",
        rating_text: "3.8",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "897",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.0",
            reviewCount: "318",
            reviewTextSmall: "318 Reviews",
            subtext: "318 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.0",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "3.6",
            reviewCount: "579",
            reviewTextSmall: "579 Reviews",
            subtext: "579 Delivery Reviews",
            color: "#E23744",
            ratingV2: "3.6",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹2,500 for two"
      },
      cfo: {
        text: "₹500 for one"
      },
      locality: {
        name: "Malviya Nagar, New Delhi",
        address:
          "T-540, The Panchshila Rendezvous, Panchshila Park, Malviya Nagar, New Delhi",
        localityUrl: "ncr/malviya-nagar-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/asian/",
          name: "Asian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/continental/",
          name: "Continental"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/chinese/",
          name: "Chinese"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/mughlai/",
          name: "Mughlai"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzNcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/mexican/",
          name: "Mexican"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/italian/",
          name: "Italian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/desserts/",
          name: "Desserts"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹2,500 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/cafe-rendezvous-malviya-nagar-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "4.1 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"2de9f85c-edd4-4afc-9c37-84016ba1773f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"nightlife","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"1037","element_type":"listing","rank":98}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "booking_cta",
        text: "Book a Table",
        clickUrl: "/ncr/cafe-rendezvous-malviya-nagar-new-delhi/book"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 2775,
      name: "Oh! Calcutta",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/5/2775/ede3a839bf67c6a78613ff992e794627_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/chains/5/2775/ede3a839bf67c6a78613ff992e794627_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/5/2775/8e3f4cc302324b2747986afc9ded0d46_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.4",
        rating_text: "4.4",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "7,038",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.6",
            reviewCount: "2,589",
            reviewTextSmall: "2,589 Reviews",
            subtext: "2,589 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.6",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "800"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.2",
            reviewCount: "4,449",
            reviewTextSmall: "4,449 Reviews",
            subtext: "4,449 Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.2",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹1,800 for two"
      },
      cfo: {
        text: "₹500 for one"
      },
      locality: {
        name: "Greater Kailash 3 (GK3), New Delhi",
        address:
          "Plot 4, Local Shopping Centre, Masjid Moth, Greater Kailash 3 (GK 3), New Delhi, Greater Kailash 3 (GK 3), New Delhi",
        localityUrl: "ncr/greater-kailash-gk-3-delhi-restaurants"
      },
      timing: {
        text: "Opens at 7pm",
        color: "#ab000d"
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/bengali/",
          name: "Bengali"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODNcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/sea-food/",
          name: "Seafood"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹1,800 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/oh-calcutta-greater-kailash-gk-3-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "2.5 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"2de9f85c-edd4-4afc-9c37-84016ba1773f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"nightlife","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"2775","element_type":"listing","rank":99}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "booking_cta",
        text: "Book a Table",
        clickUrl: "/ncr/oh-calcutta-greater-kailash-gk-3-new-delhi/book"
      },
      {
        type: "chain_cta",
        text: "View all outlets",
        clickUrl: "/ncr/restaurants/oh-calcutta?subzone=22&category=3"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 20586556,
      name: "Viet : Nom",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/6/20586556/d135c594ca735b56ee068baf20d26bc6_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/6/20586556/d135c594ca735b56ee068baf20d26bc6_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url: false
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "0",
        rating_text: "-",
        rating_subtitle: "Not rated",
        rating_color: "CBCBCB",
        votes: "0",
        subtext: "REVIEW",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "",
            reviewCount: "0",
            reviewTextSmall: "0 Reviews",
            subtext: "Does not offer Dining",
            color: "",
            ratingV2: "-",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "",
            reviewCount: "0",
            reviewTextSmall: "0 Reviews",
            subtext: "Does not offer Delivery",
            color: "",
            ratingV2: "-",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹1,800 for two"
      },
      cfo: {
        text: "₹500 for one"
      },
      locality: {
        name: "DLF Avenue, Saket, New Delhi",
        address: "DLF Avenue Mall, Press Enclave, Saket, New Delhi",
        localityUrl: "ncr/restaurants/in/dlf-avenue-saket"
      },
      timing: {
        text: "Opening to the public soon",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTlcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/vietnamese/",
          name: "Vietnamese"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/asian/",
          name: "Asian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTQzXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/health-food/",
          name: "Healthy Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/desserts/",
          name: "Desserts"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹1,800 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/viet-nom-saket-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "4.7 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"2de9f85c-edd4-4afc-9c37-84016ba1773f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"nightlife","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"20586556","element_type":"listing","rank":100}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "chain_cta",
        text: "View all outlets",
        clickUrl: "/ncr/restaurants/viet-nom?subzone=22&category=3"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 8160,
      name: "Deli Belly",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/0/8160/4fa2aa82c43cc6bb67da8f5d7696924e_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/0/8160/4fa2aa82c43cc6bb67da8f5d7696924e_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/0/8160/27ad8a8778455944de4c68e27e115382_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.7",
        rating_text: "3.7",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "196",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "3.8",
            reviewCount: "178",
            reviewTextSmall: "178 Reviews",
            subtext: "178 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "3.8",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "3.6",
            reviewCount: "18",
            reviewTextSmall: "18 Reviews",
            subtext: "18 Delivery Reviews",
            color: "#E23744",
            ratingV2: "3.6",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹2,000 for two"
      },
      cfo: {
        text: "₹500 for one"
      },
      locality: {
        name: "Jasola, New Delhi",
        address: "Shop 31, Ground Floor, DLF Tower B, Jasola, New Delhi",
        localityUrl: "ncr/jasola-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/mughlai/",
          name: "Mughlai"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/chinese/",
          name: "Chinese"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/biryani/",
          name: "Biryani"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹2,000 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/deli-belly-jasola-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "4.3 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"2de9f85c-edd4-4afc-9c37-84016ba1773f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"nightlife","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"8160","element_type":"listing","rank":101}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "booking_cta",
        text: "Book a Table",
        clickUrl: "/ncr/deli-belly-jasola-new-delhi/book"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 18462574,
      name: "PDA",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/4/18462574/81e031f204c1928fab7553d384da82c6_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/4/18462574/81e031f204c1928fab7553d384da82c6_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url: false
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.7",
        rating_text: "4.7",
        rating_subtitle: "Excellent",
        rating_color: "3F7E00",
        votes: "233",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.7",
            reviewCount: "233",
            reviewTextSmall: "233 Reviews",
            subtext: "233 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.7",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "800"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "",
            reviewCount: "0",
            reviewTextSmall: "0 Reviews",
            subtext: "Does not offer Delivery",
            color: "",
            ratingV2: "-",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹2,500 for two"
      },
      cfo: {
        text: "₹500 for one"
      },
      locality: {
        name: "Greater Kailash 2 (GK2), New Delhi",
        address: "M-8A, Greater Kailash 2 (GK 2), New Delhi",
        localityUrl: "ncr/greater-kailash-gk-2-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/italian/",
          name: "Italian"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹2,500 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/pda-greater-kailash-gk-2-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "2.7 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"2de9f85c-edd4-4afc-9c37-84016ba1773f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"nightlife","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18462574","element_type":"listing","rank":102}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "booking_cta",
        text: "Book a Table",
        clickUrl: "/ncr/pda-greater-kailash-gk-2-new-delhi/book"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 3202,
      name: "Atrium Bar & Lounge - New Delhi",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/2/3202/6a42a1e89bd5f63b2d31427fa655c903_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/2/3202/6a42a1e89bd5f63b2d31427fa655c903_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url: false
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.9",
        rating_text: "3.9",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "26",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "3.9",
            reviewCount: "26",
            reviewTextSmall: "26 Reviews",
            subtext: "26 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "3.9",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "",
            reviewCount: "0",
            reviewTextSmall: "0 Reviews",
            subtext: "Does not offer Delivery",
            color: "",
            ratingV2: "-",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹4,500 for two"
      },
      cfo: {
        text: "₹500 for one"
      },
      locality: {
        name: "The Suryaa New Delhi, New Friends Colony, New Delhi",
        address: "New Friends Colony, New Delhi.",
        localityUrl: "ncr/restaurants/in/the-suryaa-new-freinds-colony"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcxXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/finger-food/",
          name: "Finger Food"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹4,500 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl:
        "/ncr/atrium-bar-lounge-the-suryaa-new-delhi-new-friends-colony-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "2.5 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"2de9f85c-edd4-4afc-9c37-84016ba1773f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"nightlife","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"3202","element_type":"listing","rank":103}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 3298,
      name: "Voda Bar",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/8/3298/8347848dcf73a1acf5bc5d21eb391e37_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/8/3298/8347848dcf73a1acf5bc5d21eb391e37_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url: false
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.9",
        rating_text: "3.9",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "35",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "3.9",
            reviewCount: "34",
            reviewTextSmall: "34 Reviews",
            subtext: "34 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "3.9",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "",
            reviewCount: "1",
            reviewTextSmall: "1 Reviews",
            subtext: "Does not offer Delivery",
            color: "",
            ratingV2: "-",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹2,500 for two"
      },
      cfo: {
        text: "₹500 for one"
      },
      locality: {
        name: "South Extension 2, New Delhi",
        address: "E-32, South Extension 2, New Delhi",
        localityUrl: "ncr/south-extension-2-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/chinese/",
          name: "Chinese"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/mughlai/",
          name: "Mughlai"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹2,500 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/voda-bar-south-extension-2-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "3.2 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"2de9f85c-edd4-4afc-9c37-84016ba1773f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"nightlife","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"3298","element_type":"listing","rank":104}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  },
  {
    type: "restaurant",
    info: {
      resId: 8369,
      name: "Garage Inc.",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/9/8369/4b54616d9a390bf5f20aa9fdb36d5aad_featured_v2.jpg",
        urlWithParams:
          "https://b.zmtcdn.com/data/pictures/9/8369/4b54616d9a390bf5f20aa9fdb36d5aad_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/9/8369/4902e5310957b92ef46d507acb554164_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.1",
        rating_text: "4.1",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "1,450",
        subtext: "REVIEW",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.1",
            reviewCount: "1,109",
            reviewTextSmall: "1,109 Reviews",
            subtext: "1,109 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.1",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.0",
            reviewCount: "341",
            reviewTextSmall: "341 Reviews",
            subtext: "341 Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.0",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹3,000 for two"
      },
      cfo: {
        text: "₹500 for one"
      },
      locality: {
        name: "Green Park, New Delhi",
        address:
          "R-7B, Ground Floor, Green Park Extension, Opposite Uphar Cinema, Green Park, New Delhi",
        localityUrl: "ncr/green-park-delhi-restaurants"
      },
      timing: {
        text: "Temporarily closed for delivery, will be back soon!",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/continental/",
          name: "Continental"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMVwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/american/",
          name: "American"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/italian/",
          name: "Italian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTk4XCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/salad/",
          name: "Salad"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/desserts/",
          name: "Desserts"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹3,000 for two"
      }
    },
    order: [],
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/garage-inc-green-park-new-delhi/info",
      clickActionDeeplink: ""
    },
    distance: "4.1 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"2de9f85c-edd4-4afc-9c37-84016ba1773f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"nightlife","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"8369","element_type":"listing","rank":105}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [
      {
        type: "booking_cta",
        text: "Book a Table",
        clickUrl: "/ncr/garage-inc-green-park-new-delhi/book"
      }
    ],
    promoOffer: "",
    checkBulkOffers: false,
    bulkOffers: [],
    isDisabled: false,
    bottomContainers: []
  }
];
